export const BASE_URL = 'https://titlereader-dev-backend.hughjoseph.com'
